
import Vue from 'vue'
import Newsletter from './newsletter'

// @ts-ignore
import pdf from 'pdfvuer'

export default Vue.extend({
    components: {
         pdf
    },
    props: {
        newsletter: Object as () => Newsletter
    },
    data(){
        return {
            currentPage: 1,
			pageCount: 0
        }
    },
    methods: {
        prev: function () {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        },
        next: function () {
            if (this.currentPage < this.pageCount) {
                this.currentPage++;
            }
        }
    }
})
